"use strict";

exports.__esModule = true;
exports.PriceProviderType = void 0;
let PriceProviderType = /*#__PURE__*/function (PriceProviderType) {
  PriceProviderType[PriceProviderType["AGGREGATE"] = 0] = "AGGREGATE";
  PriceProviderType[PriceProviderType["MARKET"] = 1] = "MARKET";
  PriceProviderType[PriceProviderType["ORACLE"] = 2] = "ORACLE";
  PriceProviderType[PriceProviderType["DEX"] = 3] = "DEX";
  return PriceProviderType;
}({});
exports.PriceProviderType = PriceProviderType;